module.exports = __webpack_public_path__ + "static/img/12.5c6d341.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Projects/Ti/Ti-pics/12.jpg
// module id = c7Dw
// module chunks = 0